import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';

const MOCK_OPTIONS = [
  { id: 'milestone-dates', label: 'Update milestone dates' },
  { id: 'milestone-amounts', label: 'Adjust milestone amounts' },
  { id: 'milestone-scope', label: 'Add scope changes' },
  { id: 'milestone-notes', label: 'Include new notes/terms' },
];

const SowAddendumFormDialog = ({
  open,
  onClose,
  onSubmit,
  title = 'SOW Addendum',
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (!open) {
      setSelectedOptions([]);
    }
  }, [open]);

  const handleToggle = (optionId) => {
    setSelectedOptions((prev) => {
      if (prev.includes(optionId)) {
        return prev.filter((item) => item !== optionId);
      }
      return [...prev, optionId];
    });
  };

  const handleSubmit = () => {
    onSubmit?.(selectedOptions);
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      aria-labelledby='sow-addendum-form-title'
    >
      <DialogTitle id='sow-addendum-form-title' sx={{ fontWeight: 600 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ mb: 2, color: 'text.secondary' }}>
          Select the updates you want to include in the addendum.
        </Typography>
        <Box sx={{ display: 'grid', gap: 1 }}>
          {MOCK_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.id}
              control={
                <Checkbox
                  checked={selectedOptions.includes(option.id)}
                  onChange={() => handleToggle(option.id)}
                  sx={{
                    '&.Mui-checked': { color: '#2563EB' },
                  }}
                />
              }
              label={option.label}
              sx={{
                border: '1px solid #E5E7EB',
                borderRadius: 1,
                px: 1,
                py: 0.5,
                m: 0,
              }}
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant='contained'
          disabled={selectedOptions.length === 0}
        >
          Create Addendum
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SowAddendumFormDialog;
